<template>
  <div>
    <hr />
    <div class="row">
      <div class="col-md-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.code')}: *`"
          v-model="model.code"
          name="common_words.code"
          v-validate="modelValidations.code"
          :error="getError('common_words.code', true)"
          placeholder="FHg56#g67BcaeF5"
        ></fg-input>
      </div>
      <div class="col-md-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('devices.device_name')}...`"
        ></fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('devices.devices_type') }}: *</label
          >
          <br />
          <el-select
            clearable
            filterable
            class="select-primary custom-width-select required-first-step shadow-sm"
            size="large"
            v-model="model.device_type_id"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in devicesTypes"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.name"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-md-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.version')}: *`"
          v-model="model.version"
          name="common_words.version"
          v-validate="modelValidations.version"
          :error="getError('common_words.version', true)"
          placeholder="3.0"
        ></fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_a_company') }} *</label
          >
          <br />
          <el-select
            @change="selectAllFromSelect('model.business_ids', businesses)"
            clearable
            multiple
            filterable
            class="select-primary custom-width-select bus-rels shadow-sm"
            size="large"
            v-model="model.business_ids"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="option in businesses"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.name"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store';
import SweetAlert from 'src/class/Alerts';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import { Axios } from 'src/class/Axios.js';

export default {
  data() {
    return {
      model: {
        name: null,
        code: null,
        version: null,
        device_type_id: null,
        business_ids: null,
        device_name: null,
      },
      modelValidations: {
        name: {
          required: true,
        },
        code: {
          required: true,
        },
        version: {
          required: true,
        },
      },
      devicesTypes: null,
      businesses: null,
    };
  },
  mixins: [MixinPermissions, mixinMasters],

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },

    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);

          this.devicesTypes.forEach((item) => {
            if (this.model.device_type_id == item.id) {
              this.model.device_name = item.name;
            }
          });

          let others = [];
          this.businesses.forEach((item) => {
            this.model.business_ids.forEach((element) => {
              if (element == item.id) {
                others.push(item.name);
              }
            });
          });

          this.$emit('fillDeviceForm', 'firstStep', { names_business: others });
          return res;
        })
        .then((resp) => {
          if (!resp) return false;

          if (this.model.business_ids.length == 0) {
            for (let index of document.getElementsByClassName('bus-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              store.dispatch('utils/removeHasError', sel);
            }
            return false;
          } else return true;
        })
        .then((resp) => {
          if (!resp) return resp;

          return store.dispatch(
            'utils/validationInputsRequired',
            '-first-step'
          );
        });
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Axios.getMasters('devices/types')
        .then((response) => {
          this.devicesTypes = response.data.data;

          if (
            !sessionStorage.getItem('editForm') &&
            this.devicesTypes.length == 1
          )
            this.model.device_type_id = this.devicesTypes[0].id;
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });

      Axios.getMasters('businesses')
        .then((response) => {
          this.businesses = this.concatAll(response.data.data);

          if (!sessionStorage.getItem('editForm')) {
            this.model.business_ids = this.selectElementsAsignFromModel(
              1,
              this.model.business_ids,
              this.businesses
            );

            if (
              this.model.business_ids === null &&
              this.businesses.length == 1
            ) {
              this.model.business_ids.push(this.businesses[0].id);
            }
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else this.showHideLoading();
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.code = editForm.code;
      this.model.name = editForm.name;
      this.model.version = editForm.version;
      this.model.device_type_id = editForm.device_type_id;
      this.model.business_ids = editForm.business_ids;
    }
  },
};
</script>
<style></style>
